{

    const languageSwitcherOnMenubar = document.querySelector('.js-menubar-nav__language');

    // Language Tongue
    languageSwitcherOnMenubar && languageSwitcherOnMenubar.addEventListener('click', () => {
        const languageSwitcher = document.querySelector('.js-menubar-nav__language #header-language');
        languageSwitcher && languageSwitcher.classList.toggle('header-language_active');
    });

    const headerLanguages = document.querySelectorAll('#header-language');

    headerLanguages.forEach(headerLanguage => {
        headerLanguage.addEventListener('click', (e) => {
            e.preventDefault();
            let link = e.target.closest('.header-language__link');

            if (!link ) return;
            if (!link.hasAttribute('data-lang')) return;

            const domain = !document.location.host.includes('localhost')
                ? `;domain=${document.location.host.replace(/^www.|/, '.')}`
                : '';

            document.cookie = `lang_id=${link.getAttribute('data-lang')}` + domain + ';path=/';
            window.location.reload();
        });
    });
}
